import {
    ButtonGroup,
    DrawerBody,
    DrawerHeader,
    DrawerFooter,
    Flex,
    Button,
    Text,
    Drawer,
} from '@cad-arc';
import { LoadingIndicator } from '../loading-indicator';
import { useDrawerControls } from '../../../drawers/components/drawer-context-provider';
import { ExportProps } from './export';
import { getBasicCommonSize } from '../../helpers/utils';

export function ExportDrawer({
    body,
    currentExports,
    onClearAll,
    onDownloadAll,
    isLoading,
    size,
}: ExportProps) {
    const drawerControls = useDrawerControls();
    const disableButtons = isLoading || !!currentExports.length == false;
    const basicCommonSize = getBasicCommonSize(size);

    return (
        <Drawer isOpen isFullHeight size="lg" onClose={drawerControls.close}>
            <DrawerHeader>
                <Text variant="headingLg" style={{ height: '40px' }}>
                    Exports ({currentExports.length})
                </Text>
            </DrawerHeader>
            <DrawerBody sx={{ padding: 'var(--arc-space-4)' }}>
                <Flex flexDirection="column" w="100%" h="100%">
                    {isLoading ? <LoadingIndicator /> : body}
                </Flex>
            </DrawerBody>
            <DrawerFooter>
                <ButtonGroup isDisabled={disableButtons}>
                    <Button onClick={onClearAll} size={basicCommonSize}>
                        Clear All
                    </Button>
                    <Button onClick={onDownloadAll} size={basicCommonSize}>
                        Download All
                    </Button>
                </ButtonGroup>
            </DrawerFooter>
        </Drawer>
    );
}
